import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { RxCross2 } from "react-icons/rx";
import SideBar from "../../SideBar";
import Swal from "sweetalert2";
import { FaArrowLeft } from "react-icons/fa";
import HeaderName from "../../HeaderName";
import { useSelector } from "react-redux";
import { API_URL } from "../../../../api";
import ImageDropZone from "../../../common/ImageDropZone";

const Top = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 20px 30px;
`;

const Center = styled.div`
  flex: 1;
  display: inline;
  text-align: center;
`;

const Button = styled.button`
  background: rgb(0, 7, 51);
  color: white;
  justify-content: center;
  padding: 5px 30px;
  border: none;
  border-radius: 10px;
  margin-top: 20px;
`;

const Title = styled.h5`
  font-weight: bold;
  margin-top: 10px;
`;
const Div = styled.div``;
const Label = styled.label``;
const Input = styled.input`
  width: 100%;
`;
const Span = styled.span`
  color: red;
`;
const Textarea = styled.textarea``;

const Select = styled.select`
  padding: 5px 7px;
  border-radius: 5px;
`;
const Option = styled.option``;

const Table = styled.table``;
const Thead = styled.thead``;
const Tbody = styled.tbody``;
const Tr = styled.tr`
  text-align: center;
`;
const Th = styled.th`
  font-size: 15px;
`;
const Td = styled.td`
  font-size: 14px;
`;

const Create = () => {
  const token = localStorage.getItem("token");
  const url = API_URL();
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const [doctors, setDoctors] = useState([]);
  const [tName, setTName] = useState([]);
  const [therapists, setTherapists] = useState([]);
  const [procedures, setProcedures] = useState([]);
  const [machines, setMachines] = useState([]);
  const [accessories, setAccessories] = useState([]);
  const [medicineList, setMedicineList] = useState([]);
  const [items, setItems] = useState([]);
  const [isItem, setIsItem] = useState(false);
  const [id, setId] = useState("");
  const [accitems, setAccItems] = useState([]);
  const [isAccItem, setIsAccItem] = useState(false);
  const [accid, setAccId] = useState("");
  const [macitems, setMacItems] = useState([]);
  const [isMacItem, setIsMacItem] = useState(false);
  const [medItems, setMedItems] = useState([]);
  const [isMedItem, setIsMedItem] = useState(false);
  const [isNoTreatment, setIsNoTreatment] = useState(false);

  const [macid, setMacId] = useState("");
  const [totalPrice, setTotalPrice] = useState(0);
  const [percent, setPercent] = useState(0);
  const [sellPrice, setSellPrice] = useState(0);
  const [description, setDescription] = useState("");
  const [doctorname, setDoctorName] = useState("");
  const [therapistname, setTherapistName] = useState("");
  const [treatmenttime, setTreatmentTime] = useState(0);
  const [treatmentCode, setTreatmentCode] = useState("");
  const [name, setName] = useState("");
  const [image, setImage] = useState(null);

  const [errors, setErrors] = useState({
    treatementName: "",
    treatmentUnitCode: "",
    treatmentTimes: "",
    totalPrice: "",
    sellingPrice: "",
  });

  const [usageError, setUsageError] = useState({
    medicineName: "",
    procedureMedicineName: "",
    procedureAccessoryName: "",
    machineName: "",
  });

  //Pro Medicine
  const [tableProData, setTableProData] = useState([]);
  const [selectOption, setSelectOption] = useState({
    id: "",
    name: "",
  });

  //Medicine
  const [tableMedData, setTableMedData] = useState([]);
  const [selectMedOption, setSelectMedOption] = useState({
    id: "",
    name: "",
  });

  //Medicine
  const [tableProAccData, setTableProAccData] = useState([]);
  const [selectProAccOption, setSelectProAccOption] = useState({
    id: "",
    name: "",
  });

  // const name = useLocation().pathname.split('/')[3]

  const Id = useLocation().pathname.split("/")[2];

  useEffect(() => {
    const getDoctors = async () => {
      const res = await api.get("doctors");
      setDoctors(res.data.data);
    };
    const getTherapists = async () => {
      const res = await api.get("therapists");
      setTherapists(res.data.data);
    };
    const getMedicine = async () => {
      const res = await api.get("medicine-items");
      setMedicineList(res.data.list);
    };

    const getProcedures = async () => {
      const res = await api.get("procedure-items");
      setProcedures(res.data.list);
    };
    const getAccessories = async () => {
      const res = await api.get("accessory-items");
      console.log(res.data.list);
      setAccessories(res.data.list);
    };
    const getTreatment = async () => {
      console.log("treatment list");
      const res = await api.get("treatment-list/" + Id);

      setTName(res.data.data[0].name);
      console.log(res.data.data[0].name);
    };

    const getMachines = async () => {
      const res = await api.get("fixed-assets");
      setMachines(
        res.data.list.filter(
          (el) =>
            el.type == "Medical Equipment" ||
            el.type == "Surgery Equipment" ||
            el.type == "Medical Machinery",
        ),
      );
    };

    getTreatment();

    getMedicine();
    getDoctors();
    getTherapists();
    getProcedures();
    getAccessories();
    getMachines();
  }, []);

  const handleCal = (val) => {
    const res = (totalPrice / 100) * val;
    const finalRes = Number(totalPrice) + Number(res);
    setSellPrice(finalRes);
    setErrors({ ...errors, sellingPrice: "" });
    setPercent(val);
  };
  //Start procedure medicine add row

  //NOTE Input Changes when input qty and per usage qty
  const handleProInputChange = (event, id, field) => {
    const newData = tableProData.map((data) => {
      if (data.id === id) {
        return { ...data, [field]: event.target.value };
      }
      return data;
    });
    console.log(newData);
    setTableProData(newData);
  };

  //NOTE to add row of Procedure Medicine
  const handleProAddRow = (id, name) => {
    // console.log(name, 'Pro name')

    const validate = () => {
      const newErrors = {};

      if (selectOption.name === "" || selectOption.name === null) {
        newErrors.procedureMedicineName =
          "Please select Procedure Medicine  Name";
      }
      console.log("error", newErrors);
      setUsageError(newErrors);

      return Object.keys(newErrors).length === 0;
    };

    if (!validate()) return;
    setTableProData([
      ...tableProData,
      {
        id: tableProData.length + 1,
        name: name,
        item_id: id,
        quantity: "",
        perUsageQTY: "",
      },
    ]);

    // console.log(proMedName, 'pro med')
    setIsItem(true);
  };

  //NOTE to get Id and Name of procedure medicine
  const handleProGet = (event) => {
    const { options, selectedIndex } = event.target;
    const selectedOption = options[selectedIndex];
    const id = selectedOption.getAttribute("data-id");

    const proName = selectedOption.getAttribute("data-name");
    setSelectOption({
      id: id,
      name: proName,
    });

    // const value = event.target.value
    // // Use the id, name, and value as needed
    // console.log('ID:', id)
    // console.log('Name:', proName)
    // console.log('Value:', value)
  };

  //NOTE to delete proecedure medicine
  const removeProcedure = (id) => {
    setTableProData(tableProData.filter((el) => el.item_id != id));
  };
  //End procedure medicine add row

  //Start Medicine add row
  //NOTE Input Changes when input qty and per usage qty
  const handleMedInputChange = (event, id, field) => {
    const newData = tableMedData.map((data) => {
      if (data.id === id) {
        return { ...data, [field]: event.target.value };
      }
      return data;
    });
    console.log(newData);
    setTableMedData(newData);
  };

  //NOTE to add row of Procedure Medicine
  const handleMedAddRow = (id, name) => {
    // console.log(name, 'Med name')

    const validate = () => {
      const newErrors = {};

      if (selectMedOption.name === "" || selectMedOption.name === null) {
        newErrors.medicineName = "Please select Medicine Name";
      }

      setUsageError(newErrors);

      return Object.keys(newErrors).length === 0;
    };

    if (!validate()) return;
    setTableMedData([
      ...tableMedData,
      {
        id: tableMedData.length + 1,
        name: name,
        item_id: id,
        quantity: "",
        perUsageQTY: "",
      },
    ]);

    // console.log(proMedName, 'pro med')
    setIsMedItem(true);
  };

  //NOTE to get Id and Name of procedure medicine
  const handleMedGet = (event) => {
    const { options, selectedIndex } = event.target;
    const selectedOption = options[selectedIndex];
    const id = selectedOption.getAttribute("data-id");

    const medName = selectedOption.getAttribute("data-name");
    setSelectMedOption({
      id: id,
      name: medName,
    });

    // Use the id, name, and value as needed
    // console.log('ID:', id)
    // console.log('Name:', medName)
    // console.log('Value:', value)
  };

  //NOTE to delete proecedure medicine
  const removeMedicine = (id) => {
    setTableMedData(tableMedData.filter((el) => el.item_id != id));
  };

  //End Medicine add row

  //Start ProAccessory add row
  //NOTE Input Changes when input qty and per usage qty
  const handleProAccInputChange = (event, id, field) => {
    const newData = tableProAccData.map((data) => {
      if (data.id === id) {
        return { ...data, [field]: event.target.value };
      }
      return data;
    });
    console.log(newData);
    setTableProAccData(newData);
  };

  //NOTE to add row of Procedure Medicine
  const handleProAccAddRow = (id, name) => {
    // selectProAccOption
    const validate = () => {
      const newErrors = {};

      if (selectProAccOption.name === "" || selectProAccOption.name === null) {
        newErrors.procedureAccessoryName =
          "Please select Procedure Accessory  Name";
      }

      setUsageError(newErrors);

      return Object.keys(newErrors).length === 0;
    };

    if (!validate()) return;
    setTableProAccData([
      ...tableProAccData,
      {
        id: tableProAccData.length + 1,
        name: name,
        item_id: id,
        quantity: "",
        perUsageQTY: "",
      },
    ]);

    // console.log(proMedName, 'pro med')
    setIsAccItem(true);
  };

  //NOTE to get Id and Name of procedure medicine
  const handleProAccGet = (event) => {
    const { options, selectedIndex } = event.target;
    const selectedOption = options[selectedIndex];
    const id = selectedOption.getAttribute("data-id");

    const proAccName = selectedOption.getAttribute("data-name");
    setSelectProAccOption({
      id: id,
      name: proAccName,
    });

    const value = event.target.value;
    // Use the id, name, and value as needed
    console.log("ID:", id);
    console.log("Name:", proAccName);
    console.log("Value:", value);
  };

  //NOTE to delete proecedure medicine
  const removeProAcc = (id) => {
    setTableProAccData(tableProAccData.filter((el) => el.item_id != id));
  };

  //End Medicine add row

  const addMacProcedure = () => {
    const obj = {
      item_id: macid,
      quantity: 1,
      perUsageQTY: 1,
    };

    const validate = () => {
      const newErrors = {};

      if (macid === "" || macid === null) {
        console.log("fail");
        newErrors.machineName = "Please select Machine Name";
      }

      setUsageError(newErrors);

      return Object.keys(newErrors).length === 0;
    };

    if (!validate()) return;
    setMacItems((arr) => [...arr, obj]);
    setIsMacItem(true);
  };
  const removeMac = (id) => {
    setMacItems(macitems.filter((el) => el.item_id != id));
  };

  //End add table row and delete
  const create = () => {
    const data = new FormData();
    data.append("treatmentCode", treatmentCode);
    data.append("name", name);
    data.append("treatmentName", Id);
    data.append("treatmentTimes", treatmenttime);
    data.append("medicineLists", JSON.stringify(tableMedData));
    data.append("procedureMedicine", JSON.stringify(tableProData));
    data.append("procedureAccessory", JSON.stringify(tableProAccData));
    data.append("machine", JSON.stringify(macitems));
    data.append("estimateTotalPrice", totalPrice);
    data.append("discount", percent);
    data.append("sellingPrice", sellPrice);
    data.append("description", description);
    data.append("status", true);

    if (image) {
      data.append("image", image);
    }

    const validate = () => {
      const newErrors = {};
      if (!name.trim()) newErrors.treatementName = "Name is required";
      if (!treatmentCode.trim())
        newErrors.treatmentUnitCode = "Code is required";
      if (treatmenttime === 0)
        newErrors.treatmentTimes = "Times must be at least 1 time";
      if (sellPrice === 0) newErrors.sellingPrice = "Selling Price is required";
      if (totalPrice === 0) newErrors.totalPrice = "Total Price is required";

      setErrors(newErrors);

      return Object.keys(newErrors).length === 0;
    };

    if (!validate()) return;

    // alert(JSON.stringify(data))

    api
      .post("treatment", data, { headers: { "Content-Type": "multipart/form-data" } })
      .then(function (response) {
        setName("");
        setTreatmentTime(0);
        setTreatmentCode("");
        setTotalPrice(0);
        setSellPrice(0);
        setPercent(0);
        setImage(null);
        Swal.fire({
          title: "Successful!",
          text: "Successfully Created",
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
        });
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          showConfirmButton: false,
          timer: 2000,
        });
      });
  };

  const handleTreatmentName = (e) => {
    if (e.target.value.trim() !== "") {
      setErrors({
        ...errors,
        treatementName: "",
      });
    }
    setName(e.target.value);
  };

  const handleTreamentCode = (e) => {
    if (e.target.value.trim() !== "") {
      setErrors({
        ...errors,
        treatmentUnitCode: "",
      });
    }
    setTreatmentCode(e.target.value);
  };

  const handleTreamentTimes = (e) => {
    if (e.target.value.trim() !== "") {
      setErrors({
        ...errors,
        treatmentTimes: "",
      });
    }
    setTreatmentTime(e.target.value);
  };

  const handleEstimateTotalPrice = (e) => {
    const totalPrice = e.target.value;
    if (totalPrice.trim() !== "") {
      setErrors({
        ...errors,
        totalPrice: "",
        sellingPrice: "",
      });
    }

    setTotalPrice(totalPrice);
    const percentPrice = (totalPrice * percent) / 100;
    const sellingPrice = Number(totalPrice) + Number(percentPrice);
    setSellPrice(sellingPrice);
  };

  const handleSellingPrice = (e) => {
    if (e.target.value.trim() !== "") {
      setErrors({
        ...errors,
        sellingPrice: "",
      });
    }
    setSellPrice(e.target.value);
  };

  return (
    <div classNameName="App">
      <div className="wrapper">
        <div>
          {/* <!-- Content Header (Page header) --> */}
          <div className="content-header">
            <div className="container-fluid px-2">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to={"/checkUnit/" + Id}>
                        <i>
                          <FaArrowLeft />
                        </i>
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">Treatment Create</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}

          <section className="content" style={{ paddingBottom: "1.5rem" }}>
            <div className="container-fluid px-4">
              <div className="card-body row border border-dark">
                <h5>{tName ?? ""}'s Unit Create</h5>
                <div className="offset-2 col-8 py-5">
                  <div className="row">
                    <div className="col-4 form-group ">
                      <Label>
                        Treatment Unit Name<Span>*</Span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        value={name}
                        onChange={handleTreatmentName}
                      />
                      {errors.treatementName && (
                        <span style={{ color: "red" }}>
                          {errors.treatementName}
                        </span>
                      )}
                    </div>
                    <div className="col-4 form-group">
                      <Label>
                        Treatment Unit Code<Span>*</Span>
                      </Label>
                      <Input
                        type="text"
                        value={treatmentCode}
                        className="form-control"
                        onChange={handleTreamentCode}
                      />
                      {errors.treatmentUnitCode && (
                        <span style={{ color: "red" }}>
                          {errors.treatmentUnitCode}
                        </span>
                      )}
                    </div>
                    <div className="col-4 form-group">
                      <Label>
                        Treatment Times<Span>*</Span>
                      </Label>
                      <Input
                        type="text"
                        value={treatmenttime}
                        className="form-control"
                        onChange={handleTreamentTimes}
                      />
                      {errors.treatmentTimes && (
                        <span style={{ color: "red" }}>
                          {errors.treatmentTimes}
                        </span>
                      )}
                    </div>
                    {/* <div className='col-4 form-group mt-3'>
                      <Label>
                        Doctor Name<Span>*</Span>
                      </Label>
                      <Select
                        className='form-control'
                        onChange={e => setDoctorName(e.target.value)}
                      >
                        <Option>Select Doctor</Option>
                        {doctors.map((doctor, i) => (
                          <Option value={doctor._id}>{doctor.name}</Option>
                        ))}
                      </Select>
                    </div> */}
                    {/* <div className='col-4 form-group mt-3'>
                      <Label>
                        Therapist Name<Span>*</Span>
                      </Label>
                      <Select
                        className='form-control'
                        onChange={e => setTherapistName(e.target.value)}
                      >
                        <Option>Select Therapist</Option>
                        {therapists.map((therapist, i) => (
                          <Option value={therapist._id}>
                            {therapist.name}
                          </Option>
                        ))}
                      </Select>
                    </div> */}
                    <div className="col-6 form-group mt-3">
                      <Label>Medicine</Label>
                      <Select className="form-control" onChange={handleMedGet}>
                        <Option>Select Medicine</Option>
                        {medicineList.map((procedure, index) => (
                          <Option
                            value={procedure._id}
                            data-id={procedure._id}
                            data-name={procedure.medicineItemName}
                          >
                            {procedure.medicineItemName}
                          </Option>
                        ))}
                      </Select>
                      {usageError.medicineName && (
                        <p style={{ color: "red" }}>
                          {usageError.medicineName}
                        </p>
                      )}
                    </div>
                    <div className="col-3 mt-4">
                      <Button
                        onClick={(e) =>
                          handleMedAddRow(
                            selectMedOption.id,
                            selectMedOption.name,
                          )
                        }
                      >
                        Add
                      </Button>
                    </div>
                    <div className="col-12 mt-3">
                      <Table className="table table-striped">
                        <Thead>
                          <Tr>
                            <Th>No.</Th>
                            <Th>Item Name</Th>
                            <Th>Qty</Th>

                            <Th>Per Usage Qty</Th>

                            <Th></Th>
                          </Tr>
                        </Thead>
                        {isMedItem && (
                          <Tbody>
                            {tableMedData.map((item, index) => (
                              <Tr>
                                <Td>{++index}</Td>
                                <Td>{item.name}</Td>
                                <Td>
                                  <input
                                    type="number"
                                    // defaultValue={procedure.qty}
                                    defaultValue={item.quantity}
                                    onChange={(event) =>
                                      handleMedInputChange(
                                        event,
                                        item.id,
                                        "quantity",
                                      )
                                    }
                                    className="form-control"
                                  />
                                </Td>
                                {/* <Td>{procedure.purchasePrice}</Td> */}
                                <Td>
                                  <input
                                    type="number"
                                    defaultValue={item.perUsageQTY}
                                    onChange={(event) =>
                                      handleMedInputChange(
                                        event,
                                        item.id,
                                        "perUsageQTY",
                                      )
                                    }
                                    className="form-control"
                                  />
                                </Td>
                                <Td>
                                  <RxCross2
                                    onClick={() => removeMedicine(item.item_id)}
                                  />
                                </Td>
                              </Tr>
                            ))}
                          </Tbody>
                        )}
                      </Table>
                    </div>

                    {/* NOTE Procedure Medicine */}
                    <div className="col-6 form-group mt-3">
                      <Label>Procedure Medicine</Label>
                      <Select className="form-control" onChange={handleProGet}>
                        <Option>Select Procedure Medicine</Option>
                        {procedures.map((procedure, index) => (
                          <Option
                            value={procedure._id}
                            data-id={procedure._id}
                            data-name={procedure.procedureItemName}
                          >
                            {procedure.procedureItemName}
                          </Option>
                        ))}
                      </Select>
                      {usageError.procedureMedicineName && (
                        <p style={{ color: "red" }}>
                          {usageError.procedureMedicineName}
                        </p>
                      )}
                    </div>
                    <div className="col-3 mt-4">
                      <Button
                        onClick={(e) =>
                          handleProAddRow(selectOption.id, selectOption.name)
                        }
                      >
                        Add
                      </Button>
                    </div>
                    <div className="col-12 mt-4">
                      <Table className="table table-striped">
                        <Thead>
                          <Tr>
                            <Th>No.</Th>
                            <Th>Item Name</Th>
                            <Th>Qty</Th>
                            {/* <Th>Purchase Price</Th> */}
                            <Th>Per Usage Qty</Th>
                            {/* <Th>Amount</Th> */}
                            <Th></Th>
                          </Tr>
                        </Thead>
                        {isItem && (
                          <Tbody>
                            {tableProData.map((item, index) => (
                              <Tr>
                                <Td>{++index}</Td>
                                <Td>{item.name}</Td>
                                <Td>
                                  <input
                                    type="number"
                                    // defaultValue={procedure.qty}
                                    defaultValue={item.quantity}
                                    onChange={(event) =>
                                      handleProInputChange(
                                        event,
                                        item.id,
                                        "quantity",
                                      )
                                    }
                                    className="form-control"
                                  />
                                </Td>
                                {/* <Td>{procedure.purchasePrice}</Td> */}
                                <Td>
                                  <input
                                    type="number"
                                    defaultValue={item.perUsageQTY}
                                    onChange={(event) =>
                                      handleProInputChange(
                                        event,
                                        item.id,
                                        "perUsageQTY",
                                      )
                                    }
                                    className="form-control"
                                  />
                                </Td>
                                {/* <Td>{procedure.purchasePrice}</Td> */}
                                <Td>
                                  <RxCross2
                                    onClick={(e) =>
                                      removeProcedure(item.item_id)
                                    }
                                  />
                                </Td>
                              </Tr>
                            ))}
                          </Tbody>
                        )}
                      </Table>
                    </div>
                    {/* NOTE End Procedure Medicine */}

                    <div className="col-6 form-group mt-3">
                      <Label>Procedure Accessory</Label>
                      <Select
                        className="form-control"
                        onChange={handleProAccGet}
                      >
                        <Option>Select Procedure Accessory</Option>
                        {accessories.map((accessory, index) => (
                          <Option
                            value={accessory._id}
                            data-id={accessory._id}
                            data-name={accessory.accessoryItemName}
                          >
                            {accessory.accessoryItemName}
                          </Option>
                        ))}
                      </Select>
                      {usageError.procedureAccessoryName && (
                        <p style={{ color: "red" }}>
                          {usageError.procedureAccessoryName}
                        </p>
                      )}
                    </div>
                    <div className="col-3 mt-4">
                      <Button
                        onClick={(e) =>
                          handleProAccAddRow(
                            selectProAccOption.id,
                            selectProAccOption.name,
                          )
                        }
                      >
                        Add
                      </Button>
                    </div>
                    <div className="col-12 mt-3">
                      <Table className="table table-striped">
                        <Thead>
                          <Tr>
                            <Th>No.</Th>
                            <Th>Item Name</Th>
                            <Th>Qty</Th>
                            {/* <Th>Purchase Price</Th> */}
                            <Th>Per Usage Qty</Th>
                            {/* <Th>Amount</Th> */}
                          </Tr>
                        </Thead>
                        {isAccItem && (
                          <Tbody>
                            {tableProAccData.map((item, index) => (
                              <Tr>
                                <Td>{++index}</Td>
                                <Td>{item.name}</Td>
                                <Td>
                                  <input
                                    type="number"
                                    // defaultValue={procedure.qty}
                                    defaultValue={item.quantity}
                                    onChange={(event) =>
                                      handleProAccInputChange(
                                        event,
                                        item.id,
                                        "quantity",
                                      )
                                    }
                                    className="form-control"
                                  />
                                </Td>
                                {/* <Td>{procedure.purchasePrice}</Td> */}
                                <Td>
                                  <input
                                    type="number"
                                    defaultValue={item.perUsageQTY}
                                    onChange={(event) =>
                                      handleProAccInputChange(
                                        event,
                                        item.id,
                                        "perUsageQTY",
                                      )
                                    }
                                    className="form-control"
                                  />
                                </Td>
                                <Td>
                                  <RxCross2
                                    onClick={() => removeProAcc(item.item_id)}
                                  />
                                </Td>
                              </Tr>
                            ))}
                          </Tbody>
                        )}
                      </Table>
                    </div>
                    {/* NOTE End Procedure Accessory */}

                    <div className="col-6 form-group mt-3">
                      <Label>Machine</Label>
                      <Select
                        className="form-control"
                        onChange={(e) => setMacId(e.target.value)}
                      >
                        <Option>Select Machine</Option>
                        {machines.map((machine, i) => (
                          <Option value={machine._id}>{machine.name}</Option>
                        ))}
                      </Select>
                      {usageError?.machineName && (
                        <p style={{ color: "red" }}>{usageError.machineName}</p>
                      )}
                    </div>
                    <div className="col-3 mt-4">
                      <Button onClick={addMacProcedure}>Add</Button>
                    </div>
                    <div className="col-12 mt-3">
                      <Table className="table table-striped">
                        <Thead>
                          <Tr>
                            <Th>No.</Th>
                            <Th>Item Name</Th>
                            <Th>Qty</Th>
                            <Th>Purchase Price</Th>
                            <Th>Per Usage Qty</Th>
                            <Th>Amount</Th>
                          </Tr>
                        </Thead>
                        {isMacItem && (
                          <Tbody>
                            {macitems.map((macitem, index) =>
                              machines.map(
                                (machine, i) =>
                                  macitem.item_id == machine._id && (
                                    <Tr>
                                      <Td>{++index}</Td>
                                      <Td>{machine.name}</Td>
                                      <Td>1</Td>
                                      <Td>{machine.initialPrice}</Td>
                                      <Td>1</Td>
                                      <Td>{machine.initialPrice}</Td>
                                      <Td>
                                        <RxCross2
                                          onClick={() => removeMac(machine._id)}
                                        />
                                      </Td>
                                    </Tr>
                                  ),
                              ),
                            )}
                          </Tbody>
                        )}
                      </Table>
                    </div>
                    <div className="col-4 form-group mt-3">
                      <Label>
                        Estimate Total Price<Span>*</Span>
                      </Label>
                      <Input
                        type="number"
                        className="form-control"
                        value={totalPrice}
                        onChange={handleEstimateTotalPrice}
                      />
                      {errors?.totalPrice && (
                        <p style={{ color: "red" }}>{errors.totalPrice}</p>
                      )}
                    </div>
                    <div className="col-2 form-group mt-3">
                      <Label>Percent(%)</Label>
                      <Input
                        type="number"
                        value={percent}
                        className="form-control"
                        onChange={(e) => handleCal(e.target.value)}
                      />
                    </div>
                    <div className="col-4 form-group mt-3">
                      <Label>
                        Selling Price<Span>*</Span>
                      </Label>
                      <Input
                        type="number"
                        value={sellPrice}
                        className="form-control"
                        onChange={handleSellingPrice}
                      />
                      {errors?.sellingPrice && (
                        <p style={{ color: "red" }}>{errors.sellingPrice}</p>
                      )}
                    </div>
                    <div className="col-6 form-group mt-3">
                      <Label>Description</Label>
                      <Textarea
                        className="form-control"
                        onChange={(e) => setDescription(e.target.value)}
                      />
                    </div>
                    <div className="col-12 form-group mt-3">
                      <Label>Image (Optional)</Label>
                      <ImageDropZone
                        file={image}
                        onFileSelect={(file) => setImage(file)}
                        onFileRemove={() => setImage(null)}
                        label="Image"
                      />
                    </div>
                    {/* <div className='col-6 form-group mt-3'>
                      <Label>Is No Treatment ?</Label>
                      <input
                        type='checkbox'
                        className='form-control'
                        onChange={e => setIsNoTreatment(!isNoTreatment)}
                      />
                    </div> */}
                  </div>
                </div>
                <Top>
                  <Center>
                    <Button onClick={create}>Save</Button>
                  </Center>
                </Top>
              </div>
            </div>
          </section>
        </div>
      </div>
      {/* <!-- /.content-wrapper --> */}

      {/* <!-- Control Sidebar --> */}
      <aside className="control-sidebar control-sidebar-dark">
        {/* <!-- Control sidebar content goes here --> */}
      </aside>

      {/* <!-- ./wrapper --> */}
    </div>
  );
};

export default Create;
